const $$splitComponentImporter = () => import('/app/src/routes/therapist-enroll.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/therapist-enroll")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});